var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusyM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "busyM",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "otherLines"
  }, /*#__PURE__*/React.createElement("g", {
    className: "line3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_transparent",
    d: "M114.2 80.3c.2-1.8.4-3.6.4-5.4 0-4.4-.7-8.6-2-12.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "line2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_transparent",
    d: "M77.6 114.5c16.5-1.1 30.2-12.3 35.1-27.4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "mainPart"
  }, /*#__PURE__*/React.createElement("g", {
    className: "line1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_transparent",
    d: "M37.4 62c-1.4 4.1-2.2 8.4-2.2 12.9 0 20.2 15.2 36.9 34.8 39.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "wings"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_fill_transparent",
    d: "M75.3 62.2c-1.3 2.6-5 3.4-8.2 1.8-.9-.4-1.9-1.2-2.9-2.1.1 1.7-.7 3.2-2.1 3.7-1.8.7-3.9-.6-4.8-2.9-.8-2.2-.7-7.3.3-9.3 3-1.1 10.9-.5 14.1 1.1 3.3 1.7 4.9 5.1 3.6 7.7zM46.1 42.3c-.1 0-.1 0 0 0-.1.1 0 .1 0 0-1.9 1.1-7 1.4-9.3.7s-3.6-2.8-3.1-4.6c.5-1.4 1.9-2.2 3.6-2.2-.9-1-1.7-2-2.2-2.9-1.7-3.2-1.1-6.9 1.5-8.3 2.6-1.4 6 .1 7.8 3.3 1.7 3.2 2.6 11.1 1.7 14z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "bee"
  }, /*#__PURE__*/React.createElement("path", {
    className: "BUSY_special",
    d: "M37.9 62.5c-1.3-1.2-1-10.7 4.3-16.2l7.6-8c3.1-3.2 8.2-3.3 11.5-.2 3.2 3.1 3.3 8.2.2 11.5l-7.6 8c-5.5 5.7-15 5.9-16 4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main",
    d: "M46.5 42.2s2.7 8.1 11.5 11M42.1 46.7s2.7 8.1 11.5 11M38.5 52.7s2 5.8 8.7 8.8M57.9 35.9l1.6-4.2M63.7 41.5l4.1-1.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusyM);
export default __webpack_public_path__ + "static/media/busyM.0cb083756832fb4495fbd970fbdae9fe.svg";
export { ForwardRef as ReactComponent };